import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Arrow from '../../react-pointing-arrow';
import styles from './stylesheets/app.scss';

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            arrowOn: true,
        };
    }

    render() {
        const projectName = 'React Pointing Arrow';
        const authorName = 'Chris Fritz';
        const authorUrl = 'https://github.com/fritz-c';
        const githubUrl = 'https://github.com/fritz-c/react-pointing-arrow';

        return (
            <div>
                <section className={styles['page-header']}>
                    <h1 className={styles['project-name']}>{projectName}</h1>

                    <h2 className={styles['project-tagline']}>
                        A component that cares
                    </h2>
                </section>

                <section className={styles['main-content']}>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>

                    <Arrow show={this.state.arrowOn}>
                        <input />
                    </Arrow>

                    <button onClick={() => this.setState({ arrowOn: !this.state.arrowOn })}>
                        Toggle Arrow
                    </button>

                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>
                    <h3>Demo</h3>

                    <h3>Features</h3>
                    <ul>
                        <li>Points at things</li>
                        <li>Uses react-tether (which uses Tether)</li>
                    </ul>

                    <a href={githubUrl}>Documentation on Github</a>

                    <footer className={styles['site-footer']}>
                        <span className={styles['site-footer-owner']}>
                            <a href={githubUrl}>{projectName}</a> is maintained by <a href={authorUrl}>{authorName}</a>.
                        </span>

                        <span className={styles['site-footer-credits']}>
                            This page was generated by <a href="https://pages.github.com">GitHub Pages</a> using the <a href="https://github.com/jasonlong/cayman-theme">Cayman theme</a> by <a href="https://twitter.com/jasonlong">Jason Long</a>.
                        </span>
                    </footer>
                </section>

                <a href={githubUrl}>
                    <img
                        style={{ position: 'absolute', top: 0, right: 0, border: 0 }}
                        src="https://camo.githubusercontent.com/38ef81f8aca64bb9a64448d0d70f1308ef5341ab/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f6461726b626c75655f3132313632312e706e67"
                        alt="Fork me on GitHub"
                        data-canonical-src="https://s3.amazonaws.com/github/ribbons/forkme_right_darkblue_121621.png"
                    />
                </a>
            </div>
        );
    }
}

ReactDOM.render(<App />, document.getElementById('app'));



/** WEBPACK FOOTER **
 ** ./src/examples/basicExample/app.js
 **/